import {
  type CoachVideoKind,
  requiredLengthRange,
} from "apollo/lib/coach-video-length";
import { Clock } from "lucide-react";
import React from "react";
import Camera from "ui/components/icons/Camera";
import { fancyTimeFormat } from "ui/lib/helpers";
import { cn } from "ui/lib/utils";
import { STATUS_PILL } from "apollo/lib/status-tone";

export const OUTSIDE_LENGTH_CLASSES = STATUS_PILL.destructive;

export function RequiredLengthCallout({ kind }: { kind: CoachVideoKind }) {
  return (
    <div className="w-full rounded-xl border border-warning/25 bg-warning/10 px-4 py-3 text-center">
      <p className="flex items-center justify-center gap-2 text-sm font-semibold text-warning">
        <Clock className="h-4 w-4" aria-hidden="true" />
        Required length: {requiredLengthRange(kind)} seconds
      </p>
      <p className="mt-1 text-xs text-warning/70">
        Do not upload videos outside this range.
      </p>
    </div>
  );
}

export function RequiredLengthHint({
  kind,
  className,
}: {
  kind: CoachVideoKind;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-xs text-white/50",
        className
      )}
    >
      <Clock className="h-3 w-3" aria-hidden="true" />
      Length: {requiredLengthRange(kind)} sec
    </span>
  );
}

/** A video's length as a pill: neutral in range, red outside it. */
export function VideoLengthPill({
  seconds,
  outside,
  title,
  className,
}: {
  seconds: number;
  outside: boolean;
  title?: string;
  className?: string;
}) {
  return (
    <span
      title={title}
      className={cn(
        "inline-flex h-[26px] shrink-0 items-center gap-1.5 rounded-lg border px-2.5 text-[13px] font-medium",
        outside
          ? `${OUTSIDE_LENGTH_CLASSES} border-danger/30`
          : "border-white/15 bg-neutral-900/90 text-white/90",
        className
      )}
    >
      <Camera className="w-3" aria-hidden="true" />
      {fancyTimeFormat(seconds)}
    </span>
  );
}
